<template>
	<div class="view-form-h" v-if="!loading">
		<div class="divider-line"></div>
		<div class="inline-start divider">
			<img class="icon-block" src="~@/assets/png/node-icon.png" />
			<img ref="search-caption-landmark" class="list-icon" src="~@/assets/list-icon.png" />
			<div class="inline-column caption">
				<span class="zh">申领样品</span>
				<div class="en">APPLY FOR SPECIMEN
					<span>------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------</span>
				</div>
			</div>
			<i class="el-icon-arrow-down"></i>
		</div>
		<el-row v-if="model.id">
		  <el-col :span="24">
		    <el-result icon="success" :title="`${model.processState!=1 ? '提交成功,等待处理!' : '提交成功!'}`" 
				subTitle="我们将会在2个工作日与您联系!">
		      <template slot="extra">
		        <el-button class="submit-btn" type="primary" size="medium"
					@click="$router.go(-1)">返回上一页</el-button>
		      </template>
		    </el-result>
		  </el-col>
		</el-row>
		<el-form v-else ref="form" label-position="top" label-width="80px" :model="model" :rules="rules">
			<el-row :gutter="20">
				<el-col :span="14">
					<el-form-item label="姓名" prop="fullName">
						<el-input v-model="model.fullName" placeholder="请输入名字"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item label="邮箱" prop="email">
						<el-input v-model="model.email" placeholder="请输入电子邮箱"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item label="单位名称" prop="companyName">
						<el-input v-model="model.companyName" placeholder="请输入单位名称"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item label="省/自治区/直辖市" prop="address">
						<el-cascader v-model="model.address" :options="pcaTextArr" style="width: 100%;"
							placeholder="请选择" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="14">
					<el-form-item label="手机号码" prop="phoneNumber">
						<el-input v-model="model.phoneNumber" placeholder="请输入手机号码"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item label="手机验证码" prop="verCode">
						<el-input v-model="model.verCode" placeholder="请输入验证码">
							<el-button slot="append" size="mini" @click.stop="sendSms"
								:disabled="stateSms.sendBtn">
									{{!stateSms.sendBtn && '获取验证码' || (stateSms.time+' s')}}</el-button>
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item label="重点需求描述" prop="reqDes">
						<el-input type="textarea" :rows="4" placeholder="请填写您的重点需求描述" v-model="model.reqDes">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<div class="tip">有关这些处理方式的更多信息，请参阅“<span @click="onClickShowDialog">领用须知</span>”、提交此表单，即表示我确认已阅读和理解“<span @click="onClickShowDialog">领用须知</span>”</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item size="large">
						<el-button class="submit-btn" type="primary" @click="onSubmit">提交</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-dialog
		  title="领用须知"
		  :visible.sync="dialogVisible"
		  width="1024px"
		  :before-close="handleClose">
		  <div class="dialog-content" v-html="useGuide"></div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'FormH',
		mixins: [IndexMixin],
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.view-form-h {
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		flex-direction: column;

		.divider-line {
			position: absolute;
			border-right: 1px dashed rgb(49, 75, 137);
			width: calc(10px * var(--scale-rate));
			left: 0;
			top: 0;
			bottom: calc(50px * var(--scale-rate));
		}

		.divider {
			width: calc(100% - 115px * var(--scale-rate));
			margin-top: calc(30px * var(--scale-rate));
			margin-right: calc(115px * var(--scale-rate));
			overflow: hidden;
			position: relative;

			.icon-block {
				width: calc(14px * var(--scale-rate));
				height: calc(14px * var(--scale-rate));
				margin-left: calc(2.5px * var(--scale-rate));
				margin-right: calc(112px * var(--scale-rate));
			}

			.el-icon-arrow-down {
				position: absolute;
				right: 0;
			}

			.list-icon {
				width: calc(28px * var(--scale-rate));
				height: calc(28px * var(--scale-rate));
				margin-left: calc(7px * var(--scale-rate));
			}

			.caption {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				margin-left: 14px;
				//margin-top: 10px;
				line-height: 1;
				transform: scale(var(--scale-rate));
				transform-origin: left center;

				.zh {
					font-size: 25px;
					letter-spacing: 1.4px;
				}

				.en {
					width: 100%;
					font-size: 10px;
					letter-spacing: -0.8px;
					color: rgb(39, 38, 54);
					margin-top: 2px;
					margin-left: 55px;
					white-space: nowrap;
					overflow: hidden;

					span {
						letter-spacing: calc(1.4px / var(--scale-rate));
						font-size: calc(10px / var(--scale-rate));
					}
				}
			}
		}

		.el-form {
			margin-left: calc(290px * var(--scale-rate));
			margin-right: calc(260px * var(--scale-rate));
			margin-top: calc(35px * var(--scale-rate));

			::v-deep {
				.el-form-item {
					margin-bottom: 5px;
				}

				.el-form-item__label {
					padding-bottom: 0;
					color: rgb(17, 17, 17);
				}

				.el-input__inner,
				.el-textarea__inner {
					border-color: rgb(107, 107, 107);
					border-radius: 0;
				}
			}
		}

		.tip {
			font-size: 12px;
			margin-top: 10px;

			span {
				color: #FF0000;
				cursor: pointer;
			}
		}

	}
	.dialog-content {
		padding: 0 20px;
		height: 100%;
		overflow-y: scroll;
	}
	::v-deep {
		.el-dialog {
			height: 80% !important;
			margin-top: 10vh !important;
			.el-dialog__body {
				height: calc(100% - 125px);
			}
		}
	}
</style>